module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-01-c02b0966d179141e3178d7ce6973abef.svg";